enum Fetcher {
	json = "json",
	text = "text",
}

export default Fetcher;
